import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import BillingInformationViewStripe from '../BillingInformationViewStripe';
import PaymentDetailsActions from './PaymentDetailsActions';
import { storeBillingInfoStripeAttempt, verifyBillingInfoStripeAttempt } from '../BillingInformationViewStripe/actions';
import { IBillingUserInfo } from './types';

interface Props {
  brand: string;
  lastPath: string;
  updateErrorMapping: (errorMapping: any) => void;
  updateBillingInfo: (billingInfo: any) => void;
  userInfo: IBillingUserInfo;
}

const PaymentDetailsStripeElements = ({ brand, lastPath, updateErrorMapping, updateBillingInfo, userInfo }: Props) => {
  const dispatch = useDispatch();
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [errorMapping, setErrorMapping] = useState<string | null>(null);
  const formRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setSubmitDisabled(true);
      setErrorMapping(null);
      setIsLoading(true);
      // Trigger the Stripe form submission
      if (formRef.current) {
        await formRef.current.submit();
      }
    } catch (error: any) {
      setErrorMapping(error.message);
      setSubmitDisabled(false);
      setIsLoading(false);
    }
  };

  const onStripeComplete = (billingInfo: any) => {
    try {
      if (lastPath === '/payment' || lastPath === '') {
        dispatch(
          storeBillingInfoStripeAttempt({
            selectedBillingInfo: billingInfo,
          }),
        );
      } else {
        dispatch(
          verifyBillingInfoStripeAttempt({
            selectedBillingInfo: billingInfo,
          }),
        );
      }
    } catch (error: any) {
      setSubmitDisabled(false);
      setErrorMapping(error.message);
    } finally {
      setSubmitDisabled(false);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <BillingInformationViewStripe
        userInfo={userInfo}
        showPromoSection={lastPath !== '/payment' && lastPath !== ''}
        errorMessage={errorMapping}
        ref={formRef}
        onComplete={onStripeComplete}
        lastPath={lastPath}
        updateErrorMapping={updateErrorMapping}
        updateBillingInfo={updateBillingInfo}
      />
      <PaymentDetailsActions
        brand={brand}
        lastPath={lastPath}
        handleSubmit={handleSubmit}
        submitDisabled={submitDisabled}
        isLoading={isLoading}
      />
    </div>
  );
};

export default PaymentDetailsStripeElements;
